import { HelpCircle } from 'lucide-react';
import { WellnessQuestionDto } from '@repo/shared/dtos/analytics/WellnessDto';
import { HoverPopover } from '@repo/ui/components/HoverPopover';
import { cssVars } from '../shared/theme';

interface MetricTooltipProps {
  questions: WellnessQuestionDto[];
  className?: string;
}

export function MetricTooltip({ questions, className = '' }: MetricTooltipProps) {
  return (
    <div className={className}>
      <HoverPopover
        aria-label="Questions asked and value scale"
        style={cssVars}
        className="w-80 max-w-[calc(100vw-2rem)] !border-[var(--anl-border)] !bg-[var(--anl-surface-elev)] text-[var(--anl-text)]"
        trigger={
          <button
            type="button"
            aria-label="Questions asked and value scale"
            className="flex rounded-full text-[var(--anl-text-muted)] transition-colors hover:text-[var(--anl-text)] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary"
          >
            <HelpCircle className="h-4 w-4 cursor-help" />
          </button>
        }
      >
        <div className="p-4">
          <div className="mb-2 text-xs font-medium uppercase tracking-wide text-[var(--anl-text-muted)]">
            Questions Asked
          </div>
          <ul className="space-y-4">
            {questions.map(question => (
              <li key={question.questionkey}>
                <p className="text-sm leading-relaxed">{question.label}</p>
                <div className="mt-2">
                  <div className="h-3 w-full rounded-full bg-gradient-to-r from-red-700 via-yellow-600 to-green-600" />
                  <div className="mt-1 flex justify-between gap-2 text-xs font-medium text-[var(--anl-text-muted)]">
                    <span>{question.leftlabel || 'Low'}</span>
                    <span>Neutral</span>
                    <span className="text-right">{question.rightlabel || 'High'}</span>
                  </div>
                  <div className="mt-0.5 flex justify-between text-xs text-[var(--anl-text-muted)]">
                    <span>0.0</span>
                    <span>0.5</span>
                    <span>1.0</span>
                  </div>
                </div>
              </li>
            ))}
          </ul>
          <p className="mt-3 text-xs italic text-[var(--anl-text-muted)]">
            Values shown are averages of session results
          </p>
        </div>
      </HoverPopover>
    </div>
  );
}
